const delay = (time: number) => {
  return new Promise(resolve => {
    return setTimeout(resolve, time);
  });
};

export default delay;
